
import { mapState, mapGetters } from 'vuex'
import ReservationAlert from './ReservationAlert.vue'

export default {
  name: 'ReservationStatusWrapper',
  components: {
    ReservationAlert,
  },
  computed: {
    ...mapState({
      merchant: state => (state as any).api.merchant,
      reservation: state => (state as any).api.reservation,
      guest: state => (state as any).api.guest,
    }),
    ...mapGetters({
      reservationCanceled: 'api/reservationCanceled',
    }),
    guestFirstName() {
      return this.guest.firstName || (this.guest.name || '').split(/\s+/)[0]
    },
    reservationWaitlistTitleWording() {
      return this.reservation.waitlist ? 'spot in line' : 'reservation'
    },
    reservationWaitlistSubtitleWording() {
      return this.reservation.waitlist ? 'spot' : 'reservation'
    },
    confirmationWording() {
      return this.reservation.waitlist ? 'secured' : 'confirmed'
    },
    canceledTitle() {
      if (this.merchant.canceledPageTitle) {
        return this.merchant.canceledPageTitle
      }
      return this.reservation.waitlist
        ? `Thanks ${this.guestFirstName}, you've been removed from the waitlist.`
        : `Thanks ${this.guestFirstName}, your reservation has been cancelled.`
    },
    alertVariant() {
      return this.reservationCanceled ? 'info' : 'success'
    },
    confirmationTitle() {
      if (this.reservationCanceled) {
        return this.canceledTitle
      }

      return `Thanks ${this.guestFirstName}, your ${this.reservationWaitlistTitleWording} is ${this.confirmationWording}.`
    },
    canceledSubtitle() {
      return (
        this.merchant.canceledPageSubtitle ||
        'If this is a mistake, please feel free to give us a call.'
      )
    },
    confirmationSubtitle() {
      if (this.reservationCanceled) {
        return this.canceledSubtitle
      }

      return `We’re very pleased to confirm your ${this.reservationWaitlistSubtitleWording} for ${this.merchant.name}.`
    },
  },
}
